import React from 'react';

const EscapeKeyManager = ({ onCloseWidget }) => {
  React.useEffect(() => {
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      console.log('Escape key pressed2!');
      onCloseWidget();
    });
  }, []);

  return (
    <div>
      <div></div>
    </div>
  );
};

export default EscapeKeyManager;
